import React, { useState, useEffect, useRef, useContext } from "react";

import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Calendar } from "primereact/calendar";
import { InputNumber } from "primereact/inputnumber";
import { Toast } from "primereact/toast";

import { useForm } from "../../../Hooks/useForm";
import Loader from "../../../Components/Loader/Loader";
import Card from "../../../Components/Card/Card";
import { AuthContext } from "../../../Context/AuthContext/AuthContext";
import { toastShow } from "../../../Services/ToastService";
import AutoCompleteDropdown from "../../../Components/Form/AutoCompleteDropdown";

import { EditarConvenio, GuardarConvenio, ObtenerConvenioCliente, ObtenerSiguienteCorrelativo } from "../../../API/Clientes/ClientesRequest";
import { getEstadosCategoryIPS } from "../../../API/Global/Estados/StatusRequest";
import { SplitButton } from "primereact/splitbutton";

import { ConvenioDoc } from './ConvenioDoc'



const ConvenioCRUD = ({showConvenio, setShowConvenio, selected, setSelected}) => {
    const [loading, setLoading] = useState(false);
    const [estados, setEstados] = useState([]);
    const [modo, setModo] = useState(null);
    const [showReporte, setShowReporte] = useState(false);
    const [selectedR, setSelectedR] = useState([]);
    const [lenguaje, setLenguaje] = useState('es');
    const { userAuth } = useContext(AuthContext);
    const toast = useRef()

    
    const initialValues = {
        IdConvenio: -1,
        DateCreate: new Date(),
        DateConvenio: new Date(),
    };

    const { values, handleInputChange, setValues, resetForm, error, setError } = useForm(initialValues);


    const getInfo = async (IdCustomer) => {
        let idCustomer = selected?.IdCustomer ? selected?.IdCustomer : IdCustomer
        setLoading(true)

        if(selected){
            const convenioTempo = await ObtenerConvenioCliente(idCustomer)
            const estadosTempo = await getEstadosCategoryIPS('ConvenioClientes')
            setEstados(estadosTempo);

            if(convenioTempo?.length > 0){
                setModo('Editar')
                setValues({
                    ...convenioTempo[0],
                    Correlativo: convenioTempo[0]?.Correlativo,
                    Estado: convenioTempo[0]?.StatusName,
                    IdStatus: convenioTempo[0]?.IdStatus,
                    DateConvenio: new Date(convenioTempo[0]?.DateConvenio),
                    CodigoCliente: convenioTempo[0]?.CodigoCliente
                })

            }else{
                setModo('Crear')
                const correlativoTempo = await ObtenerSiguienteCorrelativo()
                setValues({
                    ...initialValues,
                    Correlativo: correlativoTempo[0]?.Correlativo,
                    IdCustomer: selected?.IdCustomer,
                    CustomerName: selected?.CustomerName,
                    CodigoCliente: selected?.CodigoCliente,
                    RTN: selected?.RTN,
                    CreditLimit: selected?.CreditLimit,
                    Direccion: selected?.Address,
                    NombreRepresentanteLegal: selected?.NombreRepresentanteLegal,
                    IdTerm: selected?.IdTerms,
                    TermName: selected?.TermName,
                    Estado: 'Activo',
                    IdStatus: 3711,
                })
            }
        }

        setTimeout(() => {
            setLoading(false)
        }, 700);

    }

    const verificarDatos = () => {
        let error = {};

        if (!values.Duracion) {
            error.Duracion = true;
            error.error = true;
        }
        if (!values.CargoExtra) {
            error.CargoExtra = true;
            error.error = true;
        }
        if (!values.MinimoCompra) {
            error.MinimoCompra = true;
            error.error = true;
        }
        if (!values.Estado || values?.Estado?.IdStatus) {
            error.IdStatus = true;
            error.error = true;
        }

        setError(error);
        return error;
    }

    const guardarConvenio = async () => {
        const e = verificarDatos()


        if(!e.error){
            setLoading(true)
            const Datos = {
                IdConvenio: values?.IdConvenio,
                IdCustomer: values?.IdCustomer,
                IdUserCreate: userAuth?.idUser,
                DateConvenio: values?.DateConvenio,
                MinimoCompra: values?.MinimoCompra,
                LimitCredit: values?.CreditLimit,
                IdTerm: values?.IdTerm,
                IdUserEdit: userAuth?.idUser,
                IdStatus: values?.Estado?.IdStatus || values?.IdStatus,
                StatusName: values?.Estado?.StatusName || values?.StatusName,
                CargoExtra: values?.CargoExtra,
                Duracion: values?.Duracion,
            }

            if(Datos?.IdConvenio > 0){
                const resp = await EditarConvenio(Datos)
                console.log(resp)

                if(resp[0]?.ESTADO === 1){
                    toastShow(toast, "success", "Datos Agregados", resp[0]?.MENSAJE);
                    getInfo(Datos?.IdCustomer)
                }else{
                    toastShow(toast, "error", "Error", 'Complete los campos requeridos.');
                }

            }else{
                const resp = await GuardarConvenio(Datos)
                console.log(resp)

                if(resp[0]?.ESTADO === 1){
                    toastShow(toast, "success", "Datos Agregados", resp[0]?.MENSAJE);
                    getInfo(Datos?.IdCustomer)
                }else{
                    toastShow(toast, "error", "Error", 'Complete los campos requeridos.');
                }
            }

            setTimeout(() => {
                setLoading(false)
            }, 300);

        }else{
            toastShow(toast, "error", "Error", 'Complete los campos requeridos.');
        }
    }

    const items = [
        {
          label: "Ingles",
          command: () => {
            setSelectedR(values)
            setLenguaje('en')
            setShowReporte(true)
          },
        },
        {
        
          label: "Español",
          command: () => {
            setSelectedR(values)
            setLenguaje('es')
            setShowReporte(true)
          },
        },
    ];
  
    const DialogFooter = (
        <React.Fragment>
        <Button
            label="Cancelar"
            icon="pi pi-times"
            className="p-button-text"
            onClick={() => setShowConvenio(false)}
        />
        <Button
            label={modo === 'Crear' ? 'Guardar' : 'Editar'}
            icon="pi pi-check"
            className="p-button-text"
            onClick={() => { guardarConvenio() }}
            loading={loading}
        />
        </React.Fragment>
    );

    useEffect(() => {
        getInfo();
    }, []);


    return (
        <div>
        <Dialog
            visible={showConvenio}
            modal
            header={<h3 className="mt-3">Convenio <strong>{values?.Correlativo}</strong></h3>}
            className="modal__contenedor modal__usuarios"
            footer={DialogFooter}
            onHide={() => setShowConvenio(false)}
            style={{ width: "700px", height: "65%" }}
            closeOnEscape={false}
        >
            <div id="Dialog">
                <Loader loading={loading} querySelector={'#Dialog'}/>
                <Toast ref={toast}/>
                <Card
                    titulo={<h5>Información del Cliente</h5>}
                    contenido={
                        <div className="mt-2">
                            <h6> <strong>Código:</strong> {values?.CodigoCliente}</h6>
                            <h6> <strong>Cliente: </strong> {values?.CustomerName}</h6>
                            <h6> <strong>RTN: </strong> {values?.RTN}</h6>
                            <h6> <strong>Límite de Crédito: </strong> {values?.CreditLimit}</h6>
                            <h6> <strong>Dirección: </strong> {values?.Address}</h6>
                            <h6> <strong>Representante: </strong> {values?.NombreRepresentanteLegal}</h6>
                            <h6> <strong>Términos de Compra: </strong>{values?.TermName}</h6>
                        </div>
                    }
                />


                <div className="d-flex mx-2 mt-4">
                    <div className="field col-6 me-2">
                        <span className="p-float-label">
                            <InputNumber
                                name="Duracion"
                                value={values.Duracion}
                                onChange={handleInputChange}
                                locale="en-US" 
                                style={{ width: "100%" }}
                                className={error.Duracion ? "p-invalid" : ""}
                            />
                            <label htmlFor="Duracion">Duración (Meses)</label>
                        </span>
                    </div>

                    <div className="field col-6 me-2">
                        <span className="p-float-label">
                            <InputNumber
                                name="CargoExtra"
                                value={values.CargoExtra}
                                onChange={handleInputChange}
                                locale="en-US" 
                                minFractionDigits={2}
                                style={{ width: "100%" }}
                                className={error.CargoExtra ? "p-invalid" : ""}
                            />
                            <label htmlFor="CargoExtra">
                                Cargo Extra ($)
                            </label>
                        </span>
                    </div>
                </div>

                <div className="d-flex mx-2 mt-4">
                    <div className="field col-6 me-2">
                        <span className="p-float-label">
                            <InputNumber
                                name="MinimoCompra"
                                value={values.MinimoCompra}
                                locale="en-US" 
                                minFractionDigits={2}
                                onChange={handleInputChange}
                                style={{ width: "100%" }}
                                className={error.MinimoCompra ? "p-invalid" : ""}
                            />
                            <label htmlFor="MinimoCompra">Mínimo Compra (Lbs)</label>
                        </span>
                    </div>

                    <div className="field col-6 me-2">
                        <span className="p-float-label">
                        <Calendar
                            id="DateConvenio"
                            name="DateConvenio"
                            value={values?.DateConvenio}
                            dateFormat="dd/mm/yy"
                            style={{ width: "100%" }}
                            mask="99/99/9999"
                            onChange={(e) => handleInputChange(e, "FechaFactura")}
                            showIcon
                        />
                        <label htmlFor="DateConvenio">Fecha Convenio</label>
                        </span>
                    </div>
                </div>

                <div className="d-flex mx-2 mt-4">
                    <div className="field col-6 me-2">
                        <span className="p-float-label">
                        <AutoCompleteDropdown
                            name={"Estado"}
                            value={values.Estado}
                            items={estados}
                            field={"StatusName"}
                            label={"Estado"}
                            handleInputChange={handleInputChange}
                            abelStyle={{
                            color: "gray",
                            textShadow: "0px 0px 1px white",
                            }}
                            className={error.IdStatus ? "p-invalid" : ""}
                        />
                        </span>
                    </div>
                </div>

                
                <div className="mt-4 mx-2">
                    <SplitButton
                        disabled={values?.IdConvenio <= 0}
                        label=""
                        icon="pi pi-print"
                        tooltip="Convenio"
                        onClick={(e) => {
                            setSelectedR(values)
                            setLenguaje('es')
                            setShowReporte(true)
                        }}
                        model={items}
                    />
                </div>


                {showReporte && (
                    <ConvenioDoc
                        showReporte={showReporte}
                        setShowReporte={setShowReporte}
                        selected={selectedR}
                        setSelected={setSelectedR}
                        lenguaje={lenguaje}
                    />
                )}

        

            </div>
        </Dialog>
        </div>
    );
};

export default ConvenioCRUD;
